<div class="row_container ptitle">
  <div class="col-12">
    <h2><strong>{{elementResultTitle}}</strong></h2>
  </div>
</div>
<div class="row print-drawer" *ngFor="let drawer of printData.drawers; let di = index">
  <div class="col-md-12" *ngIf="hasVisibleAddedElements(drawer)">
    <ng-container *ngFor="let addedElement of drawer.addedElements; let ai = index">
      <div *ngIf="!addedElement.noActiveProductsInThisElement">

        <div *ngIf="ai === 0" class="drawer-title-anchor">
          <h5 class="mt-0">{{drawer.name | uppercase}}</h5>
          <div class="d-flex align-items-center justify-content-between added-element-header">
            <div class="d-flex align-items-center">
              <img class="added-icon" [src]="uploadsImageBaseUrl + addedElement.iconPath" [alt]="addedElement.name" />
              <div class="h5 mb-0 ml-2">{{addedElement.name}}</div>
            </div>

            <!-- Element MPG / MPG After -->
            <div class="element_mpg metric-badge mki"
                 [class.mw_90]="isExistingBuildingCal">

                <div class="mpg-current"
                     *ngIf="selectedDataSet != dataSetSetting.A1A2"
                     data-test="addedElementMpg">
                    {{ addedElement.mpg | number:'.3-3' | dynamicDecimal: false }}
                </div>

                <div class="mpg-a1a2"
                     *ngIf="selectedDataSet == dataSetSetting.A1A2"
                     data-test="addedElementMpg">
                    {{ addedElement.mpg | number:'.3-3' | dynamicDecimal: true }}
                </div>

                <div class="mpg-after"
                     *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)"
                     data-test="addedElementMpgAfter">
                    {{ addedElement.mpgAfter | number:'.3-3' | dynamicDecimal: true }}
                </div>

            </div>
          </div>
        </div>

        <div *ngIf="ai !== 0" class="d-flex align-items-center justify-content-between added-element-header">
          <div class="d-flex align-items-center">
            <img class="added-icon" [src]="uploadsImageBaseUrl + addedElement.iconPath" [alt]="addedElement.name" />
            <div class="h5 mb-0 ml-2">{{addedElement.name}}</div>
          </div>

          <!-- Element MPG / MPG After -->
          <div class="element_mpg metric-badge mki"
               [class.mw_90]="isExistingBuildingCal">

              <div class="mpg-current"
                   *ngIf="selectedDataSet != dataSetSetting.A1A2"
                   data-test="addedElementMpg">
                  {{ addedElement.mpg | number:'.3-3' | dynamicDecimal: false }}
              </div>

              <div class="mpg-a1a2"
                   *ngIf="selectedDataSet == dataSetSetting.A1A2"
                   data-test="addedElementMpg">
                  {{ addedElement.mpg | number:'.3-3' | dynamicDecimal: true }}
              </div>

              <div class="mpg-after"
                   *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)"
                   data-test="addedElementMpgAfter">
                  {{ addedElement.mpgAfter | number:'.3-3' | dynamicDecimal: true }}
              </div>

          </div>
        </div>

        <!-- Added element comment -->
        <span *ngIf="addedElement.comment" class="comment_container text-muted mt-2">
          {{addedElement.comment.value}}
        </span>

        <!-- Element items -->
        <div class="element-item border-top pb-4" *ngIf="addedElement.nmdElements">
          <ng-container *ngFor="let nmdElement of addedElement.nmdElements; let ni = index">
            <div *ngIf="!nmdElement.noActiveProductsInThisElement && nmdElement.products">
              <ng-container *ngFor="let product of nmdElement.products; let pi = index">
                <div *ngIf="product.productStatusId === nmdProductStatusEnum.Active" class="product-block">
                  <div class="element-header mt-2">
                    <div class="row align-items-start" [class.existing-building-row]="isExistingBuildingCal">
                      <!-- Product Name Column -->
                      <div class="d-flex flex-column align-items-start product-column"
                           [class.col-md-5]="!isExistingBuildingCal"
                           [class.col-sm-5]="!isExistingBuildingCal"
                           [class.col-lg-5]="!isExistingBuildingCal"
                           [class.col-md-4]="isExistingBuildingCal"
                           [class.col-sm-4]="isExistingBuildingCal"
                           [class.col-lg-4]="isExistingBuildingCal">
                        <div *ngIf="pi === 0" class="small font-weight-bold nmd-element-name mt-0">{{nmdElement.name}}</div>
                        <div class="product-line mt-2">
                          <span *ngIf="product.validationCategory" class="cat-badge mr-2">Cat. {{product.validationCategory === 4 ? '3a' : (product.validationCategory || 0)}}</span>
                          <div class="product-name-row">
                            <span class="product-name" title="{{product.name}}">{{product.name}}</span>
                            <img *ngIf="product.isNlsfbElementMismatch" alt="" class="broken-link-icon ml-2" height="20" width="30" src="../../../../assets/img/broken-link.svg" />
                            <span class="product_type_ele ml-2" *ngIf="product.typeId === 2">{{'PRINT_PAGE.REUSED' | translate}}</span>
                          </div>
                          <span class="text-muted mt-2">{{product.comment}}</span>

                        </div>
                      </div>

                      <!-- Scaling Column -->
                      <div class="d-flex flex-column align-items-center header-col scaling-column"
                           [class.col-md-3]="!isExistingBuildingCal"
                           [class.col-sm-3]="!isExistingBuildingCal"
                           [class.col-lg-3]="!isExistingBuildingCal"
                           [class.col-md-2]="isExistingBuildingCal"
                           [class.col-sm-2]="isExistingBuildingCal"
                           [class.col-lg-2]="isExistingBuildingCal">
                        <div *ngIf="ni === 0 && pi === 0" class="label first-label small font-weight-bold">{{'PRINT_PAGE.SCALING' | translate}}</div>
                        <ng-container *ngIf="product?.profileSetInputs?.length > 0; else noScaling">
                          <div class="meta-note text-muted mt-2">
                            <ng-container *ngFor="let profileSet of product.profileSetInputs">
                              <div class="psets" *ngIf="profileSet.isScalable">
                                <span *ngIf="profileSet.dimensionOne">
                                  <span class="lab">{{profileSet.dimensionOne.quantityName}}</span>
                                  <span class="fld">{{profileSet.dimensionOne?.value}} <span [innerHTML]="profileSet.dimensionOne?.unit"></span></span>
                                </span>
                                <span *ngIf="profileSet.dimensionTwo" class="pl-2">
                                  <span class="lab">{{profileSet.dimensionTwo?.quantityName}}</span>
                                  <span class="fld">{{profileSet.dimensionTwo?.value}} <span [innerHTML]="profileSet.dimensionTwo?.unit"></span></span>
                                </span>
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                        <ng-template #noScaling>
                          <div class="meta-note text-muted mt-2">-</div>
                        </ng-template>
                      </div>

                      <!-- Quantity Column -->
                      <div *ngIf="!isExistingBuildingCal" class="col-md-1 col-sm-1 col-lg-1 d-flex flex-column align-items-center header-col">
                        <div *ngIf="ni === 0 && pi === 0" class="label first-label small font-weight-bold">{{'PRINT_PAGE.QUANTITY' | translate}}</div>
                        <div class="value-label text-muted mt-2">
                          {{product.amountPerUnit * addedElement.amount | number:'.0-2'}}
                          <span [innerHTML]="product.unit"></span>
                        </div>
                      </div>

                      <!-- Existing building: Current / Change / After quantities -->
                      <div *ngIf="isExistingBuildingCal" class="existing-quantity-column header-col">
                        <div class="row w-100">
                          <div class="col-4 d-flex flex-column align-items-center px-1">
                            <div *ngIf="ni === 0 && pi === 0" class="label first-label small font-weight-bold">
                              {{'COMPONENTS.PRODUCT.CURRENT' | translate}}
                            </div>
                            <div class="value-label text-muted mt-2">
                              {{product.amountPerUnit * addedElement.amount | number:'.0-2'}}
                            </div>
                          </div>

                          <div class="col-4 d-flex flex-column align-items-center px-1">
                            <div *ngIf="ni === 0 && pi === 0" class="label first-label small font-weight-bold">
                              {{'COMPONENTS.PRODUCT.CHANGE' | translate}}
                            </div>
                            <div class="value-label text-muted mt-2">
                              {{product.changeAmount | number:'.0-2'}}
                            </div>
                          </div>

                          <div class="col-4 d-flex flex-column align-items-center px-1">
                            <div *ngIf="ni === 0 && pi === 0" class="label first-label small font-weight-bold">
                              {{'COMPONENTS.PRODUCT.AFTER' | translate}}
                            </div>
                            <div class="value-label text-muted mt-2">
                              {{product.amountPerUnit + product.changeAmount | number:'.0-2'}}
                              <span [innerHTML]="product.unit"></span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- MKI Column -->
                      <div class="col-1-5 d-flex flex-column align-items-center header-col metric-col mki-column">
                        <div *ngIf="ni === 0 && pi === 0" class="label first-label small font-weight-bold">{{ mkiTitle }}</div>
                        <div class="metric-badge mki text-muted d-inline-flex flex-nowrap mt-2">
                          <div class="mpg-current" *ngIf="selectedDataSet != dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="productMpg">
                            {{selectedDataSet == dataSetSetting.A1A2 && !hasA1Data(product) ? '-' : product?.mpg || 0 | number:'.3-3' | dynamicDecimal: false}}
                          </div>
                          <div class="mpg-a1a2" *ngIf="selectedDataSet == dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="productMpg">
                            {{selectedDataSet == dataSetSetting.A1A2 && !hasA1Data(product) ? '-' : product?.mpg || 0 | number:'.3-3' | dynamicDecimal: true}}
                          </div>
                          <div class="mpg-after" *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)" data-test="productMpgAfter">
                            {{selectedDataSet == dataSetSetting.A1A2 && !hasA2Data(product)? '-' :  product?.mpgAfter || 0 | number:'.3-3' | dynamicDecimal: true}}
                          </div>
                        </div>
                      </div>

                      <!-- PPI Column -->
                      <div class="col-1-5 d-flex flex-column align-items-center header-col metric-col ppi-column">
                        <div *ngIf="ni === 0 && pi === 0" class="label first-label small font-weight-bold">{{ ppiTitle }}</div>
                        <div class="metric-badge ppi text-muted d-inline-flex flex-nowrap mt-2">
                          <div class="ppi-current" *ngIf="selectedDataSet != dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="productPpi">
                            {{selectedDataSet == dataSetSetting.A1A2 && !hasA1Data(product) ? '-' : product?.ppi || 0 | number:'.3-3' | dynamicDecimal: false}}
                          </div>
                          <div class="ppi-a1a2" *ngIf="selectedDataSet == dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="productPpi">
                            {{selectedDataSet == dataSetSetting.A1A2 && !hasA1Data(product) ? '-' : product?.ppi || 0 | number:'.3-3' | dynamicDecimal: true}}
                          </div>
                          <div class="ppi-after" *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)" data-test="productPpiAfter">
                            {{selectedDataSet == dataSetSetting.A1A2 && !hasA2Data(product)? '-' :  product?.ppiAfter || 0 | number:'.3-3' | dynamicDecimal: true}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--We will need to display this element-body if HNN module and HNN Indicator turned on-->
                  <div class="row mt-3 element-body small" *ngIf="isHnnModuleAccessible && isHNNIndicatorEnable && !product.hideHnnDataForCat3aProduct && selectedsubmenu === 'materialpassport'">
                    <div class="col-md-4 col-sm-4 col-lg-4 d-flex flex-column">
                      <div class="small mb-2 font-weight-bold">{{'PRINT_PAGE.RELEASABILITY' | translate}}</div>
                      <div>
                        <div class="text-muted small">
                          {{'PRINT_PAGE.CONNECTION_TYPE' | translate}}
                          <span *ngIf="product?.dismountability != null && product?.dismountability.connectionTypeId !== product?.epicProductData?.connectionTypeId" class="blue-dot"></span>
                        </div>
                        <div class="font-weight-bold truncate_input">{{ getConnectionTypeName(product) }}</div>
                        <div class="text-muted small mt-2">
                          {{'PRINT_PAGE.CONNECTION_ACCESSIBILITY' | translate}}
                          <span *ngIf="product?.dismountability != null && product?.dismountability?.connectionAccessibilityId !== product?.epicProductData?.connectionAccessibilityId" class="blue-dot"></span>
                        </div>
                        <div class="font-weight-bold truncate_input">{{ getConnectionAccessibility(product) }}</div>
                      </div>
                      <div class="mt-2">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.EDGE_ENCLOSURE' | translate}}
                          <span *ngIf="product?.dismountability != null && product?.dismountability?.edgeEnclosureId !== product?.epicProductData?.edgeEnclosureId" class="blue-dot"></span>
                        </div>
                        <div class="font-weight-bold truncate_input">{{ getEdgeEnclosure(product) }}</div>
                        <div class="text-muted small mt-2">
                          {{'PRINT_PAGE.PIERCING' | translate}}
                          <span *ngIf="product?.dismountability != null && product?.dismountability?.piercingId !== product?.epicProductData?.piercingId" class="blue-dot"></span>
                        </div>
                        <div class="font-weight-bold truncate_input">{{ getPiercing(product) }}</div>
                      </div>
                    </div>

                    <div class="col-md-2 col-sm-2 col-lg-2 meta-column d-flex flex-column">
                      <div class="small mb-2 font-weight-bold">{{'PRINT_PAGE.MASS_AND_VOLUME' | translate}}</div>
                      <div class="value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.MASS_PER_UNIT' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.mass !== product?.epicProductData?.mass" class="blue-dot"></span>
                        </div>
                        <strong>{{ product?.originAndReuse?.mass ?? product?.epicProductData?.mass}} <span class="right-text">{{'PRINT_PAGE.TOTAL_PRODUCT_MASS_UNIT' | translate}}</span></strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">{{'PRINT_PAGE.TOTAL_PRODUCT_MASS' | translate}}</div>
                        <strong>{{ calculateTotalMass(product) }} <span class="right-text">{{'PRINT_PAGE.TOTAL_PRODUCT_MASS_UNIT' | translate}}</span></strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">{{'PRINT_PAGE.VOLUME_PER_UNIT' | translate}}</div>
                        <strong>{{ product?.originAndReuse?.volume}} <span class="right-text">{{'PRINT_PAGE.TOTAL_PRODUCT_VOLUME_UNIT' | translate}}</span></strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">{{'PRINT_PAGE.TOTAL_PRODUCT_VOLUME' | translate}}</div>
                        <strong>{{ calculateTotalVolume(product) }} <span class="right-text">{{'PRINT_PAGE.TOTAL_PRODUCT_VOLUME_UNIT' | translate}}</span></strong>
                      </div>
                    </div>

                    <div class="col-md-3 col-sm-3 col-lg-3 meta-column d-flex flex-column">
                      <div class="small mb-2 font-weight-bold">{{'PRINT_PAGE.ORIGIN_OF_MATERIALS' | translate}}</div>
                      <div class="value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.NEW_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.new !== product?.epicProductData?.upstreamNew" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.new ?? product?.epicProductData?.upstreamNew }}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.BIOBASED_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.biobased !== product?.epicProductData?.upstreamBiobased" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.biobased ?? product?.epicProductData?.upstreamBiobased }}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.RECYCLED_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.recycled !== product?.epicProductData?.upstreamRecycled" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.recycled ?? product?.epicProductData?.upstreamRecycled}}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.REUSED_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.reused !== product?.epicProductData?.upstreamReused" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.reused ?? product?.epicProductData?.upstreamReused}}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                    </div>

                    <div class="col-md-3 col-sm-3 col-lg-3 meta-column d-flex flex-column">
                      <div class="small mb-2 font-weight-bold">{{'PRINT_PAGE.FUTURE_SCENARIO_MATERIALS' | translate}}</div>
                      <div class="value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.TO_DEPOSIT_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.dump !== product?.epicProductData?.downstreamDump" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.dump ?? product?.epicProductData?.downstreamDump}}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.BURN_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.incineration !== product?.epicProductData?.downstreamIncineration" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.incineration ?? product?.epicProductData?.downstreamIncineration}}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.RECYCLE_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.recyclable !== product?.epicProductData?.downstreamRecyclable" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.recyclable ?? product?.epicProductData?.downstreamRecyclable}}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                      <div class="mt-2 value">
                        <div class="text-muted small">
                          {{'PRINT_PAGE.REUSE_MASS' | translate}}
                          <span *ngIf="product?.originAndReuse != null && product?.originAndReuse?.reusable !== product?.epicProductData?.downstreamReusable" class="blue-dot"></span>
                        </div>
                        <strong>
                          {{ product?.originAndReuse?.reusable ?? product?.epicProductData?.downstreamReusable}}
                          <span class="right-text" data-test="NewPercentage" matSuffix>%</span>
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>